<p-card styleClass="very-compact-card p-3">
  <p class="font-bold text-xl">Настройка карточки</p>
  <ng-container *ngIf="!loading">
    <div class="p-fluid mt-3">
      <div class="field-checkbox">
        <p-checkbox
          [(ngModel)]="commonSettings.cardOnNewTab"
          (ngModelChange)="changeCommonSettings()"
          [binary]="true"
          inputId="cardOnNewTab"></p-checkbox>
        <label [for]="'cardOnNewTab'"> Открывать карточку в новой странице </label>
      </div>
    </div>
  </ng-container>

  <crm-spinner *ngIf="loading"></crm-spinner>
</p-card>
